import { render, staticRenderFns } from "./newListePropositionGazPro.vue?vue&type=template&id=2e7b4d10&scoped=true"
import script from "./newListePropositionGazPro.vue?vue&type=script&lang=js"
export * from "./newListePropositionGazPro.vue?vue&type=script&lang=js"
import style0 from "./newListePropositionGazPro.vue?vue&type=style&index=0&id=2e7b4d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7b4d10",
  null
  
)

export default component.exports